import api from '../api/api';
import axios from 'axios';
import {
  cancelDepositRequest,
  confirmDepositRequest,
  createDepositRequest,
  depositHistory,
  depositHistoryPublic,
  getAvailableDepositGateway,
  getMyDepositRequest,
  transferToBank,
} from '../api/apiHelper';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export const fetchTransferToBank = createAsyncThunk('deposit/fetchTransferToBank', async (arg, {getState, signal}) => {
  const state = await getState();
  const {uuid, bankId, bankName} = state.user.profile.user_bank || 1;
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });
  const response = await api(transferToBank({uuid, bankId, bankName}, {cancelToken: source.token}));

  return response.data;
});

export const fetchDepositHistory = createAsyncThunk('deposit/fetchHistory', async (arg, {getState, signal}) => {
  const state = await getState();
  const {uuid} = state.user.profile;
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });
  const response = await api(depositHistory({uuid}, {cancelToken: source.token}));

  return response.data;
});

export const fetchDepositHistoryPublic = createAsyncThunk('deposit/fetchHistoryPublic', async (arg, {signal}) => {
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });
  const response = await api(depositHistoryPublic({cancelToken: source.token}));
  return response.data;
});

export const fetchCreateDepositRequest = createAsyncThunk(
  'deposit/fetchCreateDepositRequest',
  async (arg, {rejectWithValue}) => {
    try {
      const response = await api(createDepositRequest(arg));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchCancelDepositRequest = createAsyncThunk('deposit/fetchCancelDepositRequest', async arg => {
  const response = await api(cancelDepositRequest(arg));
  return response.data;
});

export const fetchConfirmDepositRequest = createAsyncThunk('deposit/fetchConfirmDepositRequest', async arg => {
  const response = await api(confirmDepositRequest(arg));
  return response.data;
});

export const fetchGetMyDepositRequest = createAsyncThunk(
  'deposit/fetchGetMyDepositRequest',
  async (arg, {getState, signal}) => {
    const state = await getState();
    const {uuid} = state.user.profile;
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    const response = await api(getMyDepositRequest({uuid}, {cancelToken: source.token}));
    return response?.data;
  }
);

export const fetchAvailableDepositGateway = createAsyncThunk(
  'deposit/fetchAvailableDepositGateway',
  async (arg, {signal}) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    const response = await api(getAvailableDepositGateway({cancelToken: source.token}));
    return response.data;
  }
);

export const fetchGetMyDepositRequestStatus = createAsyncThunk(
  'deposit/fetchGetMyDepositRequestStatus',
  async (arg, {getState, signal}) => {
    const state = await getState();
    const {uuid} = state.user.profile;
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    const response = await api(getMyDepositRequest({uuid}, {cancelToken: source.token}));
    return response?.data;
  }
);

const extraReducers = {
  [fetchTransferToBank.pending]: (state, action) => {
    state.bank = {...action.payload, loading: true};
  },
  [fetchTransferToBank.fulfilled]: (state, action) => {
    state.bank = {...action.payload, loading: false};
  },
  [fetchDepositHistory.pending]: (state, action) => {
    state.history = {...action.payload, loading: true};
  },
  [fetchDepositHistory.fulfilled]: (state, action) => {
    state.history = {...action.payload, loading: false};
  },
  [fetchDepositHistoryPublic.pending]: (state, action) => {
    state.public = {...action.payload, loading: true};
  },
  [fetchDepositHistoryPublic.fulfilled]: (state, action) => {
    state.public = {...action.payload, loading: false};
  },
  [fetchCreateDepositRequest.pending]: (state, action) => {
    state.depositRequest = {...action.payload, loading: true};
  },
  [fetchCreateDepositRequest.fulfilled]: (state, action) => {
    state.depositRequest = {...action.payload, loading: false};
  },
  [fetchCreateDepositRequest.rejected]: (state, action) => {
    state.depositRequest = {...action.payload, loading: false};
  },
  [fetchGetMyDepositRequest.pending]: (state, action) => {
    state.depositRequest = {...action.payload, loading: true};
  },
  [fetchGetMyDepositRequest.fulfilled]: (state, action) => {
    state.depositRequest = {...action.payload, loading: false};
  },
  [fetchGetMyDepositRequest.rejected]: (state, action) => {
    state.depositRequest = {...action.payload, loading: false};
  },
  [fetchAvailableDepositGateway.pending]: (state, action) => {
    state.availableDepositGateway = {...action.payload, loading: true};
  },
  [fetchAvailableDepositGateway.fulfilled]: (state, action) => {
    state.availableDepositGateway = {...action.payload, loading: false};
  },
  [fetchAvailableDepositGateway.rejected]: (state, action) => {
    state.availableDepositGateway = {...action.payload, loading: false};
  },
};

const name = 'deposit';
const initialState = {
  bank: {},
  history: [],
  public: [],
  depositRequest: {loading: false},
  availableDepositGateway: {loading: false},
};
export const depositSlice = createSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    setDepositRequest: (state, action) => {
      state.depositRequest = action.payload;
    },
  },
  extraReducers,
});

// Action creators are generated for each case reducer function
export const {reset, setDepositRequest} = depositSlice.actions;

export default depositSlice.reducer;
